import { DocumentTypeEntity } from '../entities/document-type-entity';

export default class State {
  loaded = false;

  items: Array<DocumentTypeEntity> = [];
}
